export { Box } from "@mantine/core";
export type { BoxProps } from "@mantine/core";
